import { useNavigate } from "react-router-dom";
import Button from "../ui/Button/Button";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="tab_container">
            <h1>
                404: Page not found
            </h1>
            <div>
                <Button onClick={() => navigate(-1)}>
                    Back
                </Button>
            </div>
        </div>
    )
}
